import React, { useEffect, useState } from "react";
import { IoHome } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import axios from "axios";
import { toast } from 'react-toastify';
import { useAuth } from "../../Context/AuthContext";
import "./Tournaments.css";
import { MdDeleteForever } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";

const API = process.env.REACT_APP_API;

function Tournaments() {
  const navigate = useNavigate();
  const { user, token } = useAuth(); 
  const [tournaments, setTournaments] = useState([]);
  
  useEffect(() => {
    fetchTournaments();
  }, [token]);

  const fetchTournaments = async () => {
    try {
      const { data } = await axios.get(`${API}/api/tournaments`, { withCredentials: true });
      setTournaments(data);
    } catch (err) {
        console.error("Error fetching tournaments:", err);
      }
  };

  const handleDelete = async (id) => {
    if (!window.confirm(`את/ה בטוח/ה שברצונך למחוק את הטורניר?`)) return;

    try {
      await axios.delete(`${API}/api/tournaments/${id}`,
        {
          headers: {
            "Authorization": `Bearer ${token}`, // 👈 חובה
          },
        });
      setTournaments((prev) => prev.filter((t) => t._id !== id));
      toast.success('❌ הטורניר נמחק בהצלחה');
      // navigate("/tournaments");
      } catch (err) {
          console.error("שגיאה במחיקת הטורניר:", err);
          toast.error('❌ מחיקת הטורניר נכשלה');
      }
  };

  const toggleShow = async (id, newValue) => {
  try {
    const { data } = await axios.put(
      `${API}/api/tournaments/${id}`,
      { showOnWebsite: newValue },
      {
        headers: { 
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json" 
        }
      }
    );

    setTournaments((prev) =>
        prev.map((t) =>
          t._id === id ? { ...t, showOnWebsite: data.showOnWebsite } : t
        )
      );
    
    // מציג הודעה לפי הסטטוס
    if (!newValue) {
      toast.success("✅ הטורניר מוצג באתר");
    } else {
        toast.info("ℹ️ הטורניר לא מוצג באתר");
    }

  } catch (err) {
      console.error("שגיאה בעדכון טורניר:", err.response?.data || err);
      toast.error('❌ עדכון הטורניר נכשל');
  }
};

  // const tournaments = [
  //   {name: "טורנירים יומיים", url: '/DailyTournaments'},
  //   {name: "טורניר אילת", url: '/frontend/src/Components/DailyTournaments/DailyTournaments.jsx'},
  //   {name: "טורניר חוף דור", url: '/frontend/src/Components/DailyTournaments/DailyTournaments.jsx'},
  //   {name: "אליפות גלבוע", url: '/frontend/src/Components/DailyTournaments/DailyTournaments.jsx'},
  //   {name: "טורניר אתונה", url: '/frontend/src/Components/DailyTournaments/DailyTournaments.jsx'},
  //   {name: "אירועים נוספים", url: '/frontend/src/Components/DailyTournaments/DailyTournaments.jsx'},
  // ];

  return (
    <div className="tournaments-page">
      {/* אייקון הבית בפינה שמאלית עליונה */}
        <div className="home-icon" onClick={() => navigate("/")}>
          <IoHome title="עמוד הבית" size={30} />
        </div>

      <div className="header-section">
        <h1>טורנירים ואירועים</h1>
      </div>

      <div className="background-image">
        <div className="overlays">
          <div className="tournaments-wrapper">
            {user?.isAdmin && (
              <button
                className="tournaments-add-btn"
                onClick={() => navigate("/tournaments/new")}
              >
                <FaPlus /> הוספת טורניר
              </button>
            )}
            <div className="tournaments-grid">
              {tournaments
                .filter((t) => user?.isAdmin || t.showOnWebsite)
                .map((tournament, idx) => (
                  <div key={tournament._id || idx} className="tournament-item">
                    {/* <a href={(tournament.name === "טורנירים יומיים") ? "/dailyTournaments" : (tournament.name === "טורניר אילת") ? "/eilatTournaments" : " "}> </a> */}
                    
                    {/* ⭐ ניווט חדש לפי slug */}
                    <button
                      className="tournament-btn"
                      onClick={() =>
                        navigate(`/tournaments/${encodeURIComponent(tournament.slug)}`)
                      }
                    >
                      {tournament.name}
                    </button>

                    {user?.isAdmin && (
                      <>  
                        <label className="showOnWebsite">
                          <input
                            type="checkbox"
                            checked={tournament.showOnWebsite}
                            onChange={(e) => toggleShow(tournament._id, e.target.checked)}
                          /> הצג באתר
                        </label>
                        <div className="actions">
                        {/* כפתור עריכה */}
                          <FaRegEdit className="editTournament" onClick={() => navigate(`/tournaments/edit/${tournament._id}`)} size={25} color="orange" title="עריכה"/>                    
                          
                          {/* כפתור מחיקה */}
                          <MdDeleteForever className="deleteTournament" onClick={() => handleDelete(tournament._id)}  size={30} color="red" title="מחיקה"/>
                        </div>
                      </>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
        </div>
      </div>
  );
}

export default Tournaments;